import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import './Sidebar.css';

function Sidebar({ isMobile, toggleSidebar }) {
  const { currentUser, isAuthenticated, logout } = useAuth();
  const { theme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Check if the current route matches
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className={`sidebar ${isMobile ? 'mobile' : ''}`}>
      <div className="sidebar-header">
        <Link to="/" className="sidebar-logo" onClick={isMobile ? toggleSidebar : undefined}>
          <img 
            src={theme === 'dark' ? "/logo.png" : "/logo_dark.png"} 
            alt="Channls" 
            className="logo-image" 
          />
        </Link>
        {isMobile && (
          <button className="close-sidebar" onClick={toggleSidebar}>
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
      
      <nav className="sidebar-nav">
        {isAuthenticated ? (
          <>
            <div className="nav-section">
              <h3>Main</h3>
              <ul>
                <li>
                  <Link 
                    to="/dashboard" 
                    className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}
                    onClick={isMobile ? toggleSidebar : undefined}
                  >
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="7" height="7"></rect>
                      <rect x="14" y="3" width="7" height="7"></rect>
                      <rect x="14" y="14" width="7" height="7"></rect>
                      <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                    <span>Dashboard</span>
                  </Link>
                </li>
                {currentUser && (
                  <li>
                    <Link 
                      to={`/u/${currentUser.username}`} 
                      className={`nav-item ${isActive(`/u/${currentUser.username}`) ? 'active' : ''}`}
                      onClick={isMobile ? toggleSidebar : undefined}
                    >
                      <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                      <span>My Profile</span>
                    </Link>
                  </li>
                )}
              </ul>
            </div>
            
            <div className="nav-section">
              <h3>Settings</h3>
              <ul>
                <li>
                  <button 
                    onClick={handleLogout} 
                    className="nav-item"
                  >
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>Logout</span>
                  </button>
                </li>
              </ul>
            </div>
          </>
        ) : (
          <div className="nav-section">
            <ul>
              <li>
                <Link 
                  to="/login" 
                  className={`nav-item ${isActive('/login') ? 'active' : ''}`}
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                    <polyline points="10 17 15 12 10 7"></polyline>
                    <line x1="15" y1="12" x2="3" y2="12"></line>
                  </svg>
                  <span>Login</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/register" 
                  className={`nav-item ${isActive('/register') ? 'active' : ''}`}
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <line x1="20" y1="8" x2="20" y2="14"></line>
                    <line x1="23" y1="11" x2="17" y2="11"></line>
                  </svg>
                  <span>Register</span>
                </Link>
              </li>
            </ul>
          </div>
        )}
      </nav>
      
      {isAuthenticated && currentUser && (
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="avatar">
              {currentUser.name ? currentUser.name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div className="user-details">
              <p className="username">{currentUser.name || currentUser.username}</p>
              <p className="user-status">{currentUser.is_verified ? 'Verified' : 'Not Verified'}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar; 